module.exports = __webpack_public_path__ + "static/media/policies.c24cac0b.svg";